import globals from '../../globlas';
import { _sendWithAxios, _sendWithAxiosBlob } from '../api';

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API

export const gerarLinkUnico = async (data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LinkCompartilhado/gerar-link`, 'POST', data);
}

export const gerarLinkMultiplo = async (data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LinkCompartilhado/gerar-multiplos-links`, 'POST', data);
}

export const gerenciarLink = async (data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LinkCompartilhado/gerenciar-link`, 'POST', data);
}

export const removerLink = async (idLink) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LinkCompartilhado/remover-link/${idLink}`, 'DELETE');
}

export const obterLinks = async (idUsuario, page, tamanho, nomeDocumento, ordem) => {
 
  let nome = nomeDocumento 
    ? `idUsuario=${idUsuario}&pageSize=${tamanho}&pageNumber=${page}&nomeDocumento=${nomeDocumento}` 
    : `idUsuario=${idUsuario}&pageSize=${tamanho}&pageNumber=${page}`;

  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LinkCompartilhado/obter-links?${nome}&orderBy=${ordem?ordem : 'tipo asc, nomeOrdenacao asc'}`, 'GET');
}

export const detalhesLink = async (idLink) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}LinkCompartilhado/detalhe-link/${idLink}`, 'GET');
}